export default function ShowsNearbyInvalidLocation() {
  return (
    <div>
      Oops! We couldn&apos;t find shows in that location. Please try another
      city.
    </div>
  );
}
